export default __webpack_public_path__ + "static/media/clip.78fec2a3.svg";